import React, { FC } from 'react';
import {
  BurgerAuthWrapper,
  BurgerLinkStyled,
  BurgerMenuContent,
  BurgerMenuHeader,
  BurgerMenuWrapper,
  CloseButton,
  Logo,
  LogoLightWrapper,
} from './styles';
import { COLORS, MenuItem } from '@/constants';
import { CrossIcon, LogoHeader, SlideDownModal } from '@/components';
import { Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import { AuthButton } from './AuthButton';
import { LanguageSwitcher } from './LanguageSwitcher';
import { useIsProd } from '@/hooks';

type BurgerMenuProps = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  itemHighlighted: string;
  menuItems: MenuItem[];
};

export const BurgerMenu: FC<BurgerMenuProps> = ({
  isOpen,
  setIsOpen,
  itemHighlighted,
  menuItems,
}) => {
  const t = useTranslations();
  const isProd = useIsProd();

  const handleClose = () => setIsOpen(false);

  return (
    <SlideDownModal isOpen={isOpen} bgColor={COLORS['blue']} padding="20px 24px 32px" gap={0}>
      <BurgerMenuHeader>
        <Logo href="/" onClick={handleClose}>
          <LogoLightWrapper>
            <LogoHeader />
          </LogoLightWrapper>
        </Logo>
        <CloseButton onClick={handleClose}>
          <CrossIcon height={28} width={28} />
        </CloseButton>
      </BurgerMenuHeader>

      <BurgerMenuContent>
        <BurgerMenuWrapper>
          {menuItems.map(({ label, link }) => (
            <BurgerLinkStyled
              key={label}
              href={link}
              onClick={handleClose}
              $isActive={itemHighlighted === label}
            >
              <Typography
                fontSize={24}
                lineHeight={1}
                color={COLORS.white}
                fontWeight={itemHighlighted === label ? 700 : 500}
              >
                {t(label)}
              </Typography>
            </BurgerLinkStyled>
          ))}
        </BurgerMenuWrapper>

        <BurgerAuthWrapper>
          {!isProd && <LanguageSwitcher />}
          <AuthButton menuCloseCallback={handleClose} />
        </BurgerAuthWrapper>
      </BurgerMenuContent>
    </SlideDownModal>
  );
};
